module.exports = __webpack_public_path__ + "static/media/Sharecare-logo-horz white RGB.c2025afc.png";